
import ogPagesMixins from '@/mixins/ogPagesMixins'

const SEO = {
  TITLE: 'Компании в тренде за неделю | Мегасреда',
  DESCRIPTION: 'Самые популярные компании платформы на этой недели',
  H1: 'Самые популярные компании недели',
}
export default {
  mixins: [ogPagesMixins],
  async asyncData({ $axios, error }) {
    try {
      const experts = await $axios.$get('/authors/trend', {
        params: {
          accountType: 'COMPANY',
          period: 'week',
          limit: 10,
        },
      })
      return {
        experts,
      }
    } catch (err) {
      const statusCode = err.response.data.statusCode
      const message = err.response.data.message
      error({
        statusCode,
        message,
      })
    }
  },
  computed: {
    seoTitle() {
      return SEO.TITLE
    },
    seoDescription() {
      return SEO.DESCRIPTION
    },
    seoH1() {
      return SEO.H1
    },
  },
}
